import CircularProgress from '@material-ui/core/CircularProgress'
import React, { memo } from 'react'
import { useTreeViewStyles } from '../../styles/useTreeViewStyles'

import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import VisibilityOffSharpIcon from '@material-ui/icons/VisibilityOffSharp'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'
import VisibilitySharpIcon from '@material-ui/icons/VisibilitySharp'

/** Props for rendering visibility icon of <TreeView /> component */
export interface VisibilityIconProps {
    /** To check if allowed to use visibility icon */
    contentTeamFromStudioPage: boolean
    /** To check if visibility icon is disabled */
    disabled: boolean
    /* A flag whether the node is loading */
    isLoading: boolean
    /* A flag whether the node is expanded */
    isHidden: boolean
    'data-testid'?: string
    /* A utility  funtion to deactivate/activate property */
    onClickIcon: (isHidden: boolean) => void
    /* A flag whether the node is article */
    isArticle?: boolean
}

/**
 * Renders the visibility icon property of <TreeView /> component
 * @param {VisibilityIconProps} props - Props for rendering visibility icon
 * @returns {ReactElement} Node visibility icon
 */
export const VisibilityIcon = memo<VisibilityIconProps>(
    ({
        contentTeamFromStudioPage,
        isLoading,
        isHidden,
        disabled,
        onClickIcon,
        isArticle,
        'data-testid': dataTestId = 'visibility-icon',
    }) => {
        const classes = useTreeViewStyles()

        if (isLoading) {
            return (
                <CircularProgress
                    data-testid={dataTestId}
                    className={classes.switcherLoadingIcon}
                    size={16}
                />
            )
        }
        if (contentTeamFromStudioPage) return null
        return disabled ? (
            <VisibilitySharpIcon
                className={classes.visibilityIconDisabled}
                fontSize="inherit"
                htmlColor="#AAAAAA"
                onClick={() => onClickIcon(false)}
                data-testid={dataTestId}
            />
        ) : isHidden ? (
            <HoverTooltip text={'Activate Content'} placements={['bottom']}>
                <VisibilityOffSharpIcon
                    className={
                        isArticle
                            ? classes.visibilityIconArticle
                            : classes.visibilityIcon
                    }
                    fontSize="inherit"
                    onClick={() => onClickIcon(false)}
                    data-testid={dataTestId}
                />
            </HoverTooltip>
        ) : (
            <HoverTooltip text={'Inactivate Content'} placements={['bottom']}>
                <VisibilityOutlinedIcon
                    className={
                        isArticle
                            ? classes.visibilityIconArticle
                            : classes.visibilityIcon
                    }
                    fontSize="inherit"
                    onClick={() => onClickIcon(true)}
                    data-testid={dataTestId}
                />
            </HoverTooltip>
        )
    }
)
